module.exports = __webpack_public_path__ + "Nikhil-1-91f44e67.png";